export const faqData = [
  {
    question: '黄游免费下载安全吗？',
    answer: '本站所有游戏资源均经过严格的人工审核和安全检测，确保不含病毒、木马或恶意软件。我们与多家安全厂商合作，为您的下载安全保驾护航。建议下载后使用杀毒软件进行二次确认。',
  },
  {
    question: '如何下载和安装游戏？',
    answer: '找到您感兴趣的游戏后，点击游戏详情页中的下载按钮即可开始下载。PC游戏下载后通常为压缩包格式，解压后运行安装程序即可。手机游戏下载APK文件后，需要在手机设置中开启"允许安装未知来源应用"，然后点击安装。',
  },
  {
    question: '下载速度慢怎么办？',
    answer: '本站提供多条下载线路，如果当前线路速度较慢，可以尝试切换其他线路。建议在网络状况良好的环境下下载，避免使用公共WiFi。大型游戏文件推荐使用下载管理器以获得更好的下载体验。',
  },
  {
    question: '游戏更新后需要重新下载吗？',
    answer: '大部分游戏更新后可以直接下载补丁包进行升级，无需重新下载完整游戏。本站会在游戏更新后第一时间提供最新版本和升级补丁，请关注游戏详情页的更新日志。',
  },
  {
    question: '手机黄游支持iOS系统吗？',
    answer: '由于iOS系统的限制，第三方应用的安装相对复杂。部分游戏支持通过TestFlight进行安装，也有企业签名版本可供选择。具体安装方式请参考每个游戏详情页的说明。',
  },
  {
    question: '游戏无法运行怎么办？',
    answer: '请先检查您的设备是否满足游戏的最低配置要求。如果配置满足但游戏仍无法运行，可以尝试以下方法：1) 以管理员身份运行游戏；2) 安装最新的DirectX和显卡驱动；3) 关闭杀毒软件后重新安装；4) 检查游戏文件完整性。',
  },
  {
    question: '本站资源是否免费？',
    answer: '是的，本站所有游戏资源均为免费提供。我们致力于为广大玩家提供最全面的黄游免费下载服务，让每一位玩家都能享受到优质游戏的乐趣。无需付费，无需注册，直接下载。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过关于我们页面的联系表单与我们取得联系。我们的客服团队会在24小时内回复您的咨询。也可以在游戏详情页的评论区留言，我们会及时关注并回复。',
  },
];

export const testimonials = [
  {
    name: '游戏达人小王',
    content: '这个网站真的是黄游玩家的天堂！资源非常全面，而且下载速度很快。最重要的是安全可靠，再也不用担心下载到病毒了。强烈推荐给所有黄游爱好者！',
    rating: 5,
    date: '2026-08-05',
  },
  {
    name: '夜猫子玩家',
    content: '用了很多下载站，这个是体验最好的。分类清晰，更新及时，游戏介绍也很详细。手机端的游戏资源也很多，现在通勤路上也能玩了。',
    rating: 5,
    date: '2026-08-02',
  },
  {
    name: '剧情控少女',
    content: '作为一个视觉小说爱好者，这里的视觉小说资源真的太丰富了！很多小众精品都能找到，而且都有详细的评测，帮我避开了不少雷。',
    rating: 4,
    date: '2026-07-30',
  },
  {
    name: '策略大师老李',
    content: '策略战棋类的资源更新很快，每次出新作都能第一时间在这里找到。网站的安全性也让人放心，下载了这么多游戏从来没出过问题。',
    rating: 5,
    date: '2026-07-28',
  },
  {
    name: '养成系玩家小明',
    content: '养成类游戏的攻略文章写得特别好，跟着攻略玩确实事半功倍。下载速度也快，2G的游戏十几分钟就下完了，太给力了。',
    rating: 4,
    date: '2026-07-25',
  },
];

export const statsData = [
  { label: '游戏总数', value: '1,200+', icon: 'ri-gamepad-line' },
  { label: '日活跃用户', value: '50,000+', icon: 'ri-user-smile-line' },
  { label: '累计下载', value: '3,800,000+', icon: 'ri-download-cloud-2-line' },
  { label: '好评率', value: '98.6%', icon: 'ri-thumb-up-line' },
];